"use strict";

exports.__esModule = true;
exports.getHistoricalPartCountConfig = void 0;
var _featureFlags = require("../../../featureFlags");
var COLUMN_WIDTHS = {
  device: 160,
  partKind: 128,
  partProcess: 128,
  partInstance: 128,
  dateTime: 180,
  shift: 104,
  partCount: 160,
  actions: 72
};
var dataTableColumn = function dataTableColumn(props) {
  return {
    props: Object.assign({
      x: 0,
      y: 0,
      height: 64,
      width: 256
    }, props),
    children: [],
    type: "DataTableColumn"
  };
};
var actionsColumn = function actionsColumn(actionsComponent) {
  return dataTableColumn({
    id: "actions",
    name: "Actions",
    type: "actions",
    height: 72,
    defaultWidth: COLUMN_WIDTHS.actions,
    actionsComponent: actionsComponent
  });
};
var allTabColumns = function allTabColumns(segmentActions) {
  return [dataTableColumn({
    id: "deviceName",
    name: "Device",
    type: "deviceName",
    canFilter: true,
    enableSorting: false,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.device
  }), dataTableColumn({
    id: "partKind",
    name: "Part Kind",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.partKind
  }), dataTableColumn({
    id: "partProcess",
    name: "Part Process",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.partProcess
  }), dataTableColumn({
    id: "partInstance",
    name: "Part Instance",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.partInstance
  }), dataTableColumn({
    id: "startTime",
    name: "Start Time",
    type: "date",
    dateFormat: "ShortDateTime",
    usePlantTime: true,
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.dateTime
  }), dataTableColumn({
    id: "endTime",
    sortId: "device.value",
    name: "End Time",
    type: "date",
    defaultSortOrder: "DESC",
    dateFormat: "ShortDateTime",
    usePlantTime: true,
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.dateTime
  }), dataTableColumn({
    id: "workday",
    name: "Workday",
    type: "date",
    dateFormat: "ShortDateTime",
    usePlantTime: true,
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.dateTime
  }), dataTableColumn({
    id: "shift",
    name: "Shift",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.shift
  }), dataTableColumn({
    id: "goodPartCount",
    name: "Good Part Count",
    type: "number",
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.partCount
  }), dataTableColumn({
    id: "badPartCount",
    name: "Bad Part Count",
    type: "number",
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.partCount
  })].concat(segmentActions ? [actionsColumn(segmentActions)] : []);
};
var shiftTabColumns = function shiftTabColumns(shiftActions) {
  return [dataTableColumn({
    id: "deviceName",
    name: "Device",
    type: "deviceName",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.device
  }), dataTableColumn({
    id: "partKind",
    name: "Part Kind",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.partKind
  }), dataTableColumn({
    id: "partProcess",
    name: "Part Process",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.partProcess
  }), dataTableColumn({
    id: "workday",
    name: "Workday",
    type: "date",
    dateFormat: "ShortDateTime",
    usePlantTime: true,
    defaultSortOrder: "DESC",
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.dateTime
  }), dataTableColumn({
    id: "shift",
    name: "Shift",
    type: "string",
    canFilter: true,
    enableSorting: true,
    canSearch: true,
    minWidth: COLUMN_WIDTHS.shift
  }), dataTableColumn({
    id: "goodPartCount",
    name: "Good Part Count",
    type: "number",
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.partCount
  }), dataTableColumn({
    id: "badPartCount",
    name: "Bad Part Count",
    type: "number",
    enableSorting: true,
    minWidth: COLUMN_WIDTHS.partCount
  })].concat(shiftActions ? [actionsColumn(shiftActions)] : []);
};
var getHistoricalPartCountConfig = exports.getHistoricalPartCountConfig = function getHistoricalPartCountConfig(segmentActions, shiftActions) {
  return {
    id: "historicalPartCount",
    name: "HistoricalPartCount",
    element: {
      props: {
        width: 1280,
        height: 768,
        rowCount: 12,
        columnCount: 12,
        timeRangeKind: "multiDay"
      },
      children: [{
        type: "Tabs",
        props: {
          flex: 1,
          gridRowStart: 1,
          gridRowEnd: 13,
          gridColumnStart: 1,
          gridColumnEnd: 13,
          x: 0,
          y: 0,
          height: 512,
          width: 512
        },
        children: [{
          type: "Tab",
          props: {
            rowCount: 12,
            columnCount: 12,
            title: "All",
            x: 0,
            y: 0,
            height: 512,
            width: 512
          },
          children: [{
            props: {
              dataSource: "HistoricalPartCount",
              gridRowStart: 1,
              gridRowEnd: 13,
              gridColumnStart: 1,
              gridColumnEnd: 13,
              configuration: {
                enablePagination: true,
                overFetchAll: false,
                defaultPageSize: 25,
                enableFetchOnSearch: true,
                enableFetchOnSort: true,
                sort: [{
                  property: "endTime",
                  direction: "desc"
                }]
              },
              x: 0,
              y: 0,
              width: 1280,
              height: 768
            },
            children: allTabColumns(segmentActions),
            type: "DataTable"
          }]
        }, {
          type: "Tab",
          props: {
            rowCount: 12,
            columnCount: 12,
            title: "Shift",
            featureFlag: _featureFlags.ENABLE_HISTORICAL_PART_COUNT_BY_SHIFT,
            x: 0,
            y: 0,
            height: 512,
            width: 512
          },
          children: [{
            props: {
              dataSource: "HistoricalPartCountShift",
              gridRowStart: 1,
              gridRowEnd: 13,
              gridColumnStart: 1,
              gridColumnEnd: 13,
              configuration: {
                enablePagination: true,
                overFetchAll: true,
                defaultPageSize: 25
              },
              x: 0,
              y: 0,
              width: 1280,
              height: 768
            },
            children: shiftTabColumns(shiftActions),
            type: "DataTable"
          }]
        }]
      }],
      type: "Report"
    }
  };
};